import { config } from 'aws-sdk/global';
// const config = { region: 'us-east-1' };
export default config;
